//angular imports
import { ChangeDetectionStrategy, Component, EventEmitter, input,  Output,  TemplateRef } from '@angular/core';

//local imports
import { IListItem } from '@app/shared';


@Component({
    selector: 'list-items',
    templateUrl: './list-items.component.html',
    styleUrl: './list-items.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ListItemsComponent {
      
  public entities = input<IListItem[]>([]);    
  public template = input<TemplateRef<any>>(null);
  
  @Output()
  public listItemClick = new EventEmitter<IListItem>();
}
